// extracted by mini-css-extract-plugin
export default {"map__wrapper":"styles_map__wrapper__3op-f"};